module.exports = __webpack_public_path__ + "img/2021_1_12_demon_float.f98c116c.jpg";